import type { UISurfaceColors as UISurfaceColorsType } from '../types/color.type';

export const UISurfaceColors: UISurfaceColorsType = {
    Neutral: 'neutral',
    Primary: 'primary',
    Secondary: 'secondary',
    Tertiary: 'tertiary',
    Outlined: 'outlined',
} as const;
